module.exports = __webpack_public_path__ + "static/media/rewards-hero-bkg.7f1f3a98.png";